// Definition: Types for app state
export interface AppState {
  isAuth: boolean
  isAppLoading: boolean
  token: Token
  stores: Store[]
  selectedStore: SelectedStore
  layout: Layout
  planLimits?: PlanLimits
  availableModules?: string[]
  pricingPlan?: PricingPlan
}

export interface PlanLimits {
  max_products: number
  max_orders: number
  max_customers: number
  max_team_members: number
  max_locations: number
  has_website: boolean
  has_custom_domain: boolean
  has_advanced_seo: boolean
  has_api_access: boolean
  has_white_label: boolean
}

export interface JWTPayload {
  store_id: string
  product_category: string[]
  service_category: string[]
  store_domain: string
  store_verified: boolean
  available_modules: string[] | null
  plan_limits: PlanLimits
  store_type: string
  user_id: string
  email: string
  phone: string
  name: string
  user_verified: boolean
  pricing_plan: PricingPlan
  role: string
  modules: string[]
  exp: number
}

export enum LayoutType {
  FULL = 'full',
  MINI = 'mini',
  SIDEBAR = 'sidebar',
}

export enum DEVICE {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
  TABLET = 'TABLET',
}

interface Layout {
  type: LayoutType
  isMobile: boolean
}

interface Token {
  accessToken: string
  refreshToken: string
}

export interface Store {
  id: string
  store_id: string
  is_active: boolean
  role: number
  store_domain: string
  store_type: string
  metaData: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
  }
}

export interface SelectedStore {
  id: string
  store_id: string
  is_active: boolean
  role: string
  store_domain: string
  store_type: string
  location_id: string
  location_name: string
  location_type: string
  modules: string[]
}

// Pricing Plan enum matching backend constants
export enum PricingPlan {
  UNKNOWN = 0,
  BASIC = 1,
  GROWTH = 2,
  PREMIUM = 3,
  ENTERPRISE = 4,
}

// Pricing Plan utility functions
export const getPricingPlanName = (plan: PricingPlan): string => {
  switch (plan) {
    case PricingPlan.BASIC:
      return 'Basic'
    case PricingPlan.GROWTH:
      return 'Growth'
    case PricingPlan.PREMIUM:
      return 'Premium'
    case PricingPlan.ENTERPRISE:
      return 'Enterprise'
    default:
      return 'Unknown'
  }
}

export const getPricingPlanColor = (plan: PricingPlan): string => {
  switch (plan) {
    case PricingPlan.BASIC:
      return '#52c41a' // Green
    case PricingPlan.GROWTH:
      return '#1890ff' // Blue
    case PricingPlan.PREMIUM:
      return '#fa8c16' // Orange
    case PricingPlan.ENTERPRISE:
      return '#722ed1' // Purple
    default:
      return '#d9d9d9' // Gray
  }
}
